export interface SchemaOrgType {
  label: string;
  description: string;
}

export async function fetchSchemaOrgTypes(contextValue: string): Promise<SchemaOrgType[]> {
  const response = await fetch('/api/jsonld/type', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      context: contextValue
    }),
  });

  if (!response.ok) {
    // TODO: Implement proper error handling/UI feedback
    console.warn('Failed to fetch Schema.org types');
    return [];
  }

  const data = await response.json();
  return data.types;
} 